import { Component, Input } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';

import { TemplateDialogButtonBase } from '../../shared/base/template-dialog-button-base';
import { Course } from '../shared/course';

@Component({
  selector: 'app-course-members-button',
  templateUrl: './course-members-button.component.html'
})
export class CourseMembersButtonComponent extends TemplateDialogButtonBase {
  @Input() course: Course;

  constructor(dialog: MatDialog, snackBar: MatSnackBar) {
    super(dialog, snackBar);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-members-button/course-members-button.component.ts